import React from "react";
import { inject, observer } from "mobx-react";
import { Icon } from "best-common-react";
import styled from "styled-components";
import EventDataCard from "../../events/EventDataCard";
import ParkingPassFilters from "./ParkingPassFilters";

const WarningIcon = styled(Icon).attrs({ className: "mr-2" })`
  &&& {
    color: #ff9100;
  }
`;

const Information = styled.div.attrs({ className: "mt-2" })`
  &&& {
    color: #ff9100;
  }
`;

function ParkingPassBody(props) {
  const { parkingPassStore, authStore, commonStore } = props.rootStore;
  parkingPassStore.setGamePK(props.gamePK);
  parkingPassStore.setReturnToReservations(props.from);
  if (!parkingPassStore.game.venue) {
    return <div>No Event</div>;
  }

  return (
    <div className="row">
      <div className="col-lg-3 col-md-5">
        <EventDataCard game={parkingPassStore.game} displayCountdown={false} title="" />
        {parkingPassStore.game.resumedFromDate ? (
          <Information>
            <span>
              <WarningIcon iconName="fa-info-circle" />
            </span>
            Game resumed from {parkingPassStore.game.resumedFromDate}
          </Information>
        ) : null}
      </div>

      <div className="col-lg-9 col-md-7 mt-1">
        <ParkingPassFilters game={parkingPassStore.game} id="parking-pass-filters" />
      </div>
    </div>
  );
}

export default inject("rootStore")(observer(ParkingPassBody));
